export const getProgressStatusOptions = ({ isDeliveryOrder, isTakeawayOrder, isProviderOrder }) => {
  const options = [
    { label: 'New', value: 'New' },
    { label: 'In Progress', value: 'In_Progress' },
    { label: 'Ready', value: 'Ready' },
  ];

  if (isDeliveryOrder) {
    options.push({ label: 'Delivering', value: 'Delivering' });
    options.push({ label: 'Delivered', value: 'Delivered' });
  }

  if (!isProviderOrder) {
    options.push({ label: 'Completed', value: 'Completed' });
    options.push({ label: 'Canceled', value: 'Canceled' });
  }

  return options;
};
